import React from 'react';
import {Switch, Route, useRouteMatch} from 'react-router-dom';

import Paper from '@material-ui/core/Paper';

import CreateCampaign from './CreateCampaign/CreateCampaign';
import CampaignsTable from './CampaignsTable';
import ViewCampaign from './ViewCampaign';

const Campaigns = () => {
	const match = useRouteMatch();
	const BASE_PATH = match.path;

	return (
		<Paper elevation={2}>
			<Switch>
				<Route path={`${BASE_PATH}/create`}>
					<CreateCampaign />
				</Route>
				<Route path={`${BASE_PATH}/table`}>
					<CampaignsTable />
				</Route>
				<Route path={`${BASE_PATH}/:campaign_id`}>
					<ViewCampaign />
				</Route>
			</Switch>
		</Paper>
	)
}

export default Campaigns;